import React, { useState, useEffect, useRef } from 'react';

// Generický jednovýberový dropdown (vlastný vzhľad namiesto natívneho <select>).
// Rovnaká štruktúra ako ostatné multiselecty; mieru zaoblenia riadi `className`
// (napr. "single-select--soft" pre jemnejšie rohy).
export default function SingleSelect({ value, onChange, options = [], placeholder = '', className = '' }) {

    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);

    const selected = options.find((o) => String(o.value) === String(value));

    useEffect(() => {
        const onDocClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, []);

    const pick = (v) => {
        onChange(v);
        setIsOpen(false);
    };

    return (
        <div className={`mill-multiselect single-select ${className}`} ref={ref}>
            <div className="multiselect-line" onClick={() => setIsOpen((o) => !o)}>
                <div className="selected-values">
                    <span className={`single-select-value ${selected ? '' : 'single-select-placeholder'}`}>
                        {selected ? selected.label : placeholder}
                    </span>
                </div>
                <span className="dropdown-icon material-symbols-outlined">
                    {isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
                </span>
            </div>
            {isOpen && (
                <div className="dropdown-menu">
                    <ul className="dropdown-list">
                        {placeholder && (
                            <li
                                className={`dropdown-item ${!value ? "selected" : ""}`}
                                onClick={() => pick('')}
                            >
                                {placeholder}
                            </li>
                        )}
                        {options.map((option) => (
                            <li
                                key={option.value}
                                className={`dropdown-item ${String(option.value) === String(value) ? "selected" : ""}`}
                                onClick={() => pick(option.value)}
                            >
                                {option.label}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
